import { useEffect, useState } from "react";
import { getServiceWithESimToActivateListRoute } from "@api-routes/eirCustomersFacade";
import { useFetch } from "@common/hook/useFetch";
import {
    getResponseToState,
    IServiceWithESimToActivateListResponse,
} from "@features/ManageSim/mappers/getServiceWithESimToActivateListMapper";
import { IServiceWithESimToActivate } from "@features/ManageSim/interface/IServiceWithESimToActivate";
import { useFetchState } from "@hook/useFetchState";

export const useGetServiceWithESimToActivateList = () => {
    const [, { get }] = useFetch();
    const { endFetching, isLoading, startFetching } = useFetchState();
    const [serviceWithESimToActivateList, setServiceWithESimToActivateList] = useState<IServiceWithESimToActivate[]>();

    useEffect(() => {
        startFetching();
        get<IServiceWithESimToActivateListResponse[]>(getServiceWithESimToActivateListRoute())
            .then((response) => {
                if (response) {
                    setServiceWithESimToActivateList(getResponseToState(response));
                }
            })
            .finally(() => endFetching());
    }, [endFetching, get, startFetching]);

    return { isLoading, serviceWithESimToActivateList };
};
